import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ArrowSvg from './kbd-arrow-up.svg';
import arrowStyles from './Arrow.css';
import defaultSvgAttributes from './defaultSvgAttributes.js';

const Arrow = ({direction, type, className, ...props}) => (
  <ArrowSvg
    {...defaultSvgAttributes} 
    {...props}
    className={classNames(arrowStyles.hxArrow, className, arrowStyles[direction], arrowStyles[type])}
    preserveAspectRatio="xMidYMid meet"
  />
);

Arrow.propTypes = {
  direction: PropTypes.string.isRequired,
  type: PropTypes.string,
  className: PropTypes.string
};

Arrow.defaultProps = {
  direction: 'down'
};

export default Arrow;
